export function calcCost({
  inputTokens = 0,
  outputTokens = 0,
  reasoningTokens = 0,
  inputPrice = 0,
  outputPrice = 0,
  reasoningPrice = 0,
}) {
  const total =
    inputTokens * inputPrice +
    outputTokens * outputPrice +
    reasoningTokens * reasoningPrice;
  return +total.toFixed(2);
}

export function getDaysOfMonth(year, month) {
  const result = [];
  let d = new Date(year, month - 1, 1);
  while (d.getMonth() === month - 1) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    result.push(`${yyyy}-${mm}-${dd}`);
    d.setDate(d.getDate() + 1);
  }
  return result;
}

// Transform usage data for dot chart visualization
export function transformForDotChart(perDayModel, modelPricing) {
  const dots = [];
  const chartColors = [
    'var(--color-chart-1)',
    'var(--color-chart-2)',
    'var(--color-chart-3)',
    'var(--color-chart-4)',
    'var(--color-chart-5)',
    'var(--color-chart-6)',
    'var(--color-chart-7)',
    'var(--color-chart-8)',
    'var(--color-chart-9)',
    'var(--color-chart-10)'
  ];
  
  perDayModel.forEach((day, dayIndex) => {
    let dayTotalCost = 0;
    let dayTotalTokens = 0;
    const modelBreakdown = [];
    
    day.models.forEach((m, modelIndex) => {
      const modelInfo = modelPricing[m.model_id];
      if (modelInfo) {
        const pricing = modelInfo.price;
        const displayName = modelInfo.display_name;
        const totalCost = calcCost({
          inputTokens: m.input_tokens,
          outputTokens: m.output_tokens,
          reasoningTokens: m.reasoning_tokens || 0,
          inputPrice: pricing.input_tokens,
          outputPrice: pricing.output_tokens,
          reasoningPrice: pricing.reasoning_tokens,
        });
        
        const totalTokens = m.input_tokens + m.output_tokens + (m.reasoning_tokens || 0);
        
        dayTotalCost += totalCost;
        dayTotalTokens += totalTokens;
        
        modelBreakdown.push({
          name: displayName,
          cost: totalCost,
          tokens: totalTokens,
          inputTokens: m.input_tokens,
          outputTokens: m.output_tokens,
          reasoningTokens: m.reasoning_tokens || 0,
          color: chartColors[modelIndex % chartColors.length]
        });
      }
    });
    
    if (modelBreakdown.length > 0) {
      const dateObj = new Date(day.day);
      const formattedDate = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      
      // Create description with model breakdown
      const descriptionLines = modelBreakdown.map(model => 
        `${model.name}: $${model.cost.toFixed(2)} (${model.tokens.toLocaleString()} tokens)`
      ).join('\n');
      
      dots.push({
        date: dateObj,
        value: dayTotalCost,
        tokens: dayTotalTokens,
        color: chartColors[dayIndex % chartColors.length],
        label: `${formattedDate} - $${dayTotalCost.toFixed(2)}`,
        description: descriptionLines,
        dayString: day.day,
        modelBreakdown: modelBreakdown
      });
    }
  });
  
  return dots;
}
